export default __webpack_public_path__ + "static/media/atorfit.ee6d070b.png";